// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"960f1ad4","1102":"df36d96b","6406":"df36d96b"}[chunkId] + ".chunk.css";
};